import axios from "axios";

const getToken = () => {
  return localStorage.getItem("ntk");
};

const headers = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: token,
    },
  };
};

const profile = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/get-admin`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const editprofile = async (data, image) => {
  try {
    const params = new FormData();
    params.append("fullName", data.name);
    params.append("mobilenumber", data.number);
    params.append("email", data.email);
    {
      image && params.append("image", image);
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-admin`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const changepassword = async (values) => {
  try {
    const params = {
      oldPassword: values.oldpassword,
      newPassword: values.password,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/change-pass`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const dashboard = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/dashboard`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const dayweekuser = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/analytics-join`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const userage = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/user-segment`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const usercategory = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/segment-bycategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const joincategory = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/category-performance`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const conversionRate = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/post-conversion`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const frequent = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/frequent-joiner`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const nojoin = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/clicked-not-joined`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const monthlyuser = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/current-month-users`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const masterdata = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/Master-Data-Management`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const updatemasterdata = async (params) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/admin/Master-Data-Management`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const category = async (page, search) => {
  try {
    const params = {
      page: page,
      search: search,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-category`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const addcategory = async (name) => {
  try {
    const params = {
      Name: name,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/add-category`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
const deletecategory = async (id) => {
  try {
    const params = {
      id: id,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-category`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
const editcategory = async (id, name) => {
  try {
    const params = {
      id: id,
      Name: name,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-category`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
const subcategory = async (page, search) => {
  try {
    const params = {
      page: page,
      search: search,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const addsubcategory = async (id, name, image) => {
  try {
    const params = new FormData();
    params.append("category_id", id);
    params.append("Name", name);
    params.append("image", image);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/add-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
const deletesubcategory = async (id) => {
  try {
    const params = {
      id: id,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
const editsubcategory = async (id, value, image) => {
  try {
    const params = new FormData();
    params.append("id", id);
    params.append("category_id", value.type);
    image && params.append("image", image);
    params.append("Name", value.name);
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-subcategory`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

const userlist = async (page, searchvalue, filter) => {
  try {
    const params = {
      page: page,
      search: searchvalue,
      filter: filter,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-user`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const deleterestoreuser = async (id) => {
  try {
    const params = {
      id: id,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-user`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const blockunblockuser = async (id, value) => {
  try {
    const params = {
      id: id,
      isBlock: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/block-unblock`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const suspendeduser = async (id, value) => {
  try {
    const params = {
      id: id,
      isSuspend: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/block-unblock`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const userdetails = async (value) => {
  try {
    const params = {
      id: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/user/details`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const post = async (page, deleted) => {
  try {
    const params = {
      page: page,
      deletedOnly: deleted,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-post`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const cancelpost = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/cancelqes-users`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const postdetails = async (value) => {
  try {
    const params = {
      postId: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/post-details`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const deletepost = async (value) => {
  try {
    const params = {
      postId: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-post`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const memberremove = async (value, id) => {
  try {
    const params = {
      postId: value,
      memberId: id,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/member-remove`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const customerservicelist = async ({
  page = 1,
  pageSize = 10,
  search = "",
  filter = "all",
  sortBy = "createdAt",
  sortOrder = "DESC",
} = {}) => {
  try {
    const params = {
      page,
      pageSize,
      search,
      filter,
      sortBy,
      sortOrder,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-customerservice`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const serviceaction = async (id, reply) => {
  try {
    const params = {
      id: id,
      reply: reply,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/reply-service`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const customerservicedetails = async (id) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/customer-service-details`,
      { id },
      headers(),
    );
  } catch (error) {
    throw error.response?.data || error;
  }
};

const customerservicestats = async () => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/customer-service-stats`,
      {},
      headers(),
    );
  } catch (error) {
    throw error.response?.data || error;
  }
};

const deletecustomerservice = async (id) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-customerservice`,
      { id },
      headers(),
    );
  } catch (error) {
    throw error.response?.data || error;
  }
};
const reportlist = async ({ page = 1, pageSize = 10, search = "" } = {}) => {
  try {
    const params = { page, pageSize, search };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-report`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

const deletereport = async (id) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/delete-report`,
      { id },
      headers(),
    );
  } catch (error) {
    throw error.response?.data || error;
  }
};

const blockunblock = async (value, status) => {
  try {
    const params = {
      id: value,
      action: status,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/block-unblock`,
      params,
      headers(),
    );
    console.log(response);
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const getdoc = async (value) => {
  try {
    const params = {
      id: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/legal-data`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const updatedoc = async (value, data) => {
  try {
    const params = {
      id: value,
      english_content: data,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/update-legal-docs`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const reportdetails = async (value) => {
  try {
    const params = {
      id: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/post/reported-details`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const postaction = async (id, action, reason) => {
  try {
    const params = {
      id: id,
      action: action,
      admin_reason: reason,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/post/reported-action`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

// ------------------------no used

const userdetailsmasterdata = async (params) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/UserMasterData`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const getterms = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/TermsAndCondition`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const getprivacy = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/PrivacyPolicy`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const contactlist = async (page) => {
  try {
    const params = {
      page: page,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/ContactUsList`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const contactdetails = async (value) => {
  try {
    const params = {
      id: value,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/ContactDetails`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const sendreply = async (id, email, msg) => {
  try {
    const params = {
      id: id,
      user_email: email,
      reply_msg: msg,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/ReplyContactUs`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

const SendPushNftTo = async (value, usertoken) => {
  try {
    const params = {
      title: value.title,
      message: value.message,
      device_token: usertoken,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/SendPushNftTo`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const GetCities = async () => {
  try {
    const params = {};
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/get-cities`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
export const SendMaintenanceInfo = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/maintenance-info`,
      payload,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const SendPushNftToALl = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/push-notification`,
      payload,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

const language = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/admin/LanguageList`,
      headers(),
    );
    return response;
  } catch (error) {
    throw error.response.data;
  }
};
const languagestatus = async (value, status) => {
  try {
    const params = {
      id: value,
      status: status ? "2" : "1",
    };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/ChangeLangStatus`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

const addlanguage = async (name, img) => {
  try {
    const params = new FormData();
    params.append("image", img);
    params.append("name", name);
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/admin/AddLanguage`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
const editlanguage = async (name, img, id) => {
  try {
    const params = new FormData();
    {
      img && params.append("image", img);
    }
    params.append("name", name);
    params.append("id", id);

    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/admin/UpdateLanguage`,
      params,
      headers(),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export default profile;
export {
  editprofile,
  changepassword,
  masterdata,
  monthlyuser,
  updatemasterdata,
  userlist,
  deleterestoreuser,
  blockunblockuser,
  suspendeduser,
  userdetails,
  blockunblock,
  getdoc,
  updatedoc,
  reportlist,
  deletereport,
  reportdetails,
  postaction,
  dashboard,
  dayweekuser,
  userage,
  frequent,
  nojoin,
  usercategory,
  joincategory,
  conversionRate,
  getterms,
  getprivacy,
  userdetailsmasterdata,
  contactlist,
  contactdetails,
  sendreply,
  SendPushNftTo,
  SendPushNftToALl,
  language,
  addlanguage,
  languagestatus,
  editlanguage,
  category,
  addcategory,
  editcategory,
  deletecategory,
  subcategory,
  addsubcategory,
  editsubcategory,
  deletesubcategory,
  post,
  cancelpost,
  postdetails,
  deletepost,
  memberremove,
  customerservicelist,
  serviceaction,
  customerservicedetails,
  customerservicestats,
  deletecustomerservice,
};
